// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1m3qO","image":"Header_image__-G9ZP","name":"Header_name__1YUqW","info":"Header_info__1V872","infoRow":"Header_infoRow__2Ua2N"};